export const promotionFieldMapping = {
  details: [
    'couponSchemeId',
    'schemeName',
    'schemeType',
    'schemeStatus',
    'sponsor',
    'createdOn'
  ],
  validity: [
    'creationStartDateTime',
    'creationEndDateTime',
    'redemptionEndDateTime'
  ],
  discount: [
    'discountValue',
    'discountArticleEan'
  ],
  usage: [
    'usageLimitPerCoupon',
    'maxCouponsToGenerate'
  ],
  configuration: [
    'defaultDurationDays',
    'couponBarcodePrefix',
    'couponBarcodeType',
    'redemptionCallbackURL'
  ]
}
